// src/components/Quotation/QuotationItemsTable.jsx
import React from "react";

const cols = [
  "Product Name","HSN Code","Unit","Qty","Rate","Amount",
  "Discount","Taxable Value","CGST%","CGST Amt","SGST%",
  "SGST Amt","IGST%","IGST Amt","Total"
];

const QuotationItemsTable = ({ items = [] }) => (
  <div style={{ overflowX: "auto" }}>
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5 }}>
      <thead>
        <tr style={{ background: "#F9FAFB" }}>
          {cols.map(c => (
            <th key={c} style={th}>{c}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.length === 0 ? (
          <tr>
            <td colSpan={cols.length} style={{ textAlign: "center", padding: 24, color: "#6B7280" }}>
              No product items found.
            </td>
          </tr>
        ) : items.map((item, i) => (
          <tr key={item.id || i} style={{ borderBottom: "0.5px solid #F3F4F6" }}>
            <td style={td}>{item.productName || "—"}</td>
            <td style={td}>{item.productHSNCode || "—"}</td>
            <td style={td}>{item.unitMeasure || "—"}</td>
            <td style={td}>{item.productQty ?? "—"}</td>
            <td style={td}>₹{item.productRate ?? 0}</td>
            <td style={td}>₹{item.productAmount ?? 0}</td>
            <td style={td}>₹{item.productDiscount ?? 0}</td>
            <td style={td}>₹{item.productTaxableValue ?? 0}</td>
            <td style={td}>{item.productCGSTRate ?? 0}%</td>
            <td style={td}>₹{item.productCGSTAmount ?? 0}</td>
            <td style={td}>{item.productSGSTRate ?? 0}%</td>
            <td style={td}>₹{item.productSGSTAmount ?? 0}</td>
            <td style={td}>{item.productIGSTRate ?? 0}%</td>
            <td style={td}>₹{item.productIGSTAmount ?? 0}</td>
            <td style={{ ...td, fontWeight: 600, color: "#111827" }}>₹{item.productTotal ?? 0}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const th = { padding: "8px 10px", textAlign: "left", fontSize: 11, fontWeight: 600, color: "#6B7280", whiteSpace: "nowrap", borderBottom: "0.5px solid #E5E7EB" };
const td = { padding: "9px 10px", color: "#374151", whiteSpace: "nowrap" };

export default QuotationItemsTable;
